import { SET_ACCESS_TOKEN_DATA, SET_USER_DATA, SET_LOGGED_IN } from '../actions/auth';

const INITIAL_UI_STATE = {
    isLoggedIn: false,
};

export const authUIReducer = (state = INITIAL_UI_STATE, action) => {
    switch (action.type) {
        case SET_LOGGED_IN:
            return {
                ...state,
                isLoggedIn: action.payload,
            };
        default:
            return state;
    }
};

const INITIAL_DATA_STATE = {
    tokenData: {},
    userData: {},
};

export const authDataReducer = (state = INITIAL_DATA_STATE, action) => {
    switch (action.type) {
        case SET_ACCESS_TOKEN_DATA:
            return {
                ...state,
                tokenData: action.payload,
            };
        case SET_USER_DATA:
            return {
                ...state,
                userData: action.payload,
            };
        default:
            return state;
    }
};
